<template>
    <div class="add-popup-component" :style="height">
        <div class="add-popup-container" ref="addChannelPopup">
            <div class="global_popup_header">{{title}}<i @click="$store.commit('windowHandle')"></i></div>
            <div class="global_popup_body">
                <el-form :model="formData" :rules="rules" ref="formData" @submit.native.prevent label-position="top" class="itemAlter">
                    <el-form-item v-for="item in ruleProps" :key="item.prop" :label="item.label" :prop="item.prop" @keyup.enter.native="submitForm('formData')">
                        <el-input v-model="formData[item.prop]" :placeholder="item.placeholder"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="global_popup_footer">
                <button @click="submitForm('formData')">{{$t('commonMsg.confirm')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String
        },

        ruleForm: {
            type: Object
        },

        ruleProps: {
            type: Array
        },

        rules: {
            type: Object
        }
    },
    computed: {
        formData() {
            this.data = Object.assign({}, this.ruleForm)
            return this.data
        }
    },
    data(){
        return {
            data: null,
            height: ''
        }
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$emit('addEditEvn', this.data)
                    this.$store.commit("windowHandle")
                } else {
                    return false;
                }
            })
        }
    },
    mounted() {
        this.height = `height: ${this.$refs.addChannelPopup.clientHeight}px`
    }


}
</script>

<style lang="scss" scoped>
    .add-popup-component{
        @include globalPopup();
        .add-popup-container{
            background:#fff;
            border-radius: 4px;
        }
    }
</style>


